import * as React from "react"
import { ExternalLink } from "lucide-react"

import { cn } from "@/lib/utils"

/**
 * The feed the report is about, styled as the panel's subheadline.
 *
 * Takes the size, weight and leading of the account page's PageHeading
 * description (text-sm / font-medium / leading-5) but keeps a link's colour and
 * underline: it is the subject of the report AND the one thing in the panel a
 * reader may want to open, and on the public share page it is the only fact
 * orienting someone who arrived with no other context.
 *
 * A component rather than inline markup because the share page renders its own
 * header and needs the identical treatment.
 */
export default function MedicFeedLink({
  feedUrl,
  className,
}: {
  feedUrl?: string
  className?: string
}) {
  if (!feedUrl) return null

  return (
    <a
      href={feedUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "tw:flex tw:items-center tw:gap-1.5 tw:text-sm tw:leading-5 tw:font-medium",
        "tw:text-primary tw:underline tw:decoration-primary/30 tw:underline-offset-4 tw:hover:decoration-primary",
        className
      )}
    >
      <span className="tw:min-w-0 tw:break-all">{feedUrl}</span>
      <ExternalLink aria-hidden="true" className="tw:size-3.5 tw:shrink-0" />
    </a>
  )
}
